<template>
  <SidePanel
    :isVisible="true"
    @cancel="onCancel"
    @save="onSave"
    :header="$t('create.dlgHeaderEdit')"
    :save="$t('create.dlgSaveDone')"
    :cancel="$t('general.cancel')"        
    :rightCommand="true"
    :leftCommand="true"    

  >
    <div class="sidepanel-body">
      <div class="panel-section-title text-weight-semi-bold">
        {{ $t('options.sectionChoices') }}
      </div>
      <p class="text-size-14">
        {{ $t('options.sectionChoicesDecription') }}
      </p>

      <div v-for="(choice, index) in choices" :key="choice.id">
        <div class="choice-item m-0">
          <div class="col-1 h6 text-number mt-1">{{ index + 1 }}</div>
          <div class="col-10">
            <InputText
              :key="choice.id"
              :label="$t('options.lblOption')"
              v-model="choices[index].text"
            />
          </div>
          <div
            @click="removeChoice(choice.id)"
            class="col-1 d-flex remove-icon justify-content-center align-items-center"
          >
            <div class="">
              <font-awesome-icon :icon="['fal', 'trash-alt']" />
            </div>
          </div>
        </div>
      </div>

      <div @click="addChoice" class="add-item text-primary m-3">
        <font-awesome-icon
          class="text-primary mt-1"
          :icon="['fal', 'plus-circle']"
        />
        {{ $t('options.linkAddOption') }}
      </div>
      <div class="sidepanel-footer"></div>      
    </div>
  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import InputText from '@/components/UI/InputText.vue';



import { mapState } from 'vuex';

export default {
  name: 'EditChoices',

  props: [],
  
  components: {
    SidePanel,
    InputText,
  },

  data() {
    return {
      newId: -1,
      localDetails: null,
      backup: null,
      currentTabComponent: 'app-option-time',
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    }),

    choices() {
      let choices = this.poll.choices.filter(
        (choice) => choice.start == null && choice.end == null
      );

      if (choices.length == 0) {
        this.addChoice();
        this.addChoice();
        choices = this.poll.choices.filter(
          (choice) => choice.start == null && choice.end == null
        );
      }
      return choices;
    },

    isNewPoll() {
      return this.poll.options.initialised == false;
    },
  },

  watch: {},

  methods: {
    onCancel() {
      if (!this.isNewPoll) {
        //this.$store.dispatch('updateChoices', this.backup);
      }
      this.$emit('cancel');
    },

    onSave() {
      console.log('Update poll choices with:', this.poll.choices);
      this.$store.dispatch('updateChoicesNoSort', this.poll.choices);
      if (this.isNewPoll) {
        let options = this.poll.options;
        options.initialised = true;
        this.$store.commit('updateOptions', options);
      }
      this.$emit('save');
    },

    addChoice() {
      let choice = {
        id: this.newId--,
        poll_id: this.poll.id,
        start: null,
        end: null,
        text: null,
        limit: null
      };
      let choices = [...this.poll.choices, choice];
      console.log('add new choice :', choices);
      this.$store.commit('updateChoicesNoSort', choices);
    },

    removeChoice(id) {
      console.log('Remove choice:', id);
      let choices = this.poll.choices.filter((item) => item.id != id);
      console.log({ choices });
      this.$store.commit('updateChoicesNoSort', choices);
    },
  },

  mounted() {
    let choices = this.poll.choices;
    this.backup = JSON.parse(JSON.stringify(choices));

  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.text-number {
  color: $date-color;
  display: flex;
  align-items: center;
  justify-content: center;
}

.choice-item {
  display: flex;
  flex-direction: row;
}

.add-item,
.remove-icon {
  cursor: pointer;
}

.remove-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
